import React from "react";
import QurealCanvasWrapper from "./QurealCanvasWrapper";
import { Button, Carousel, Popconfirm, message } from "antd";
import { useMeasure, useMedia } from "react-use";
import { MenuOutlined, DeleteOutlined } from "@ant-design/icons";
import SocialPostingBox from "../../social_media/SocialPostingBox";
import { useDeleteItemMutation } from "../../_actions/app/items";
import { queryClient } from "../../_helpers/query";
import log from "cslog"

function QurealExternalPostCanvas({ data, closeBtn, entry_id, platforms, open_cust, setOpenCust, me, close = () => { } }) {
    const [ref] = useMeasure();
    const isMobile = useMedia("(max-width: 700px)");
    const org_id = me?.selected_org?.id;

    const deleteMutation = useDeleteItemMutation(() => {
        message.success("Entry deleted successfully!");
        queryClient.invalidateQueries(["items", "qdb_calendar_entries"]);
        close();
    });

    const media = data?.media || [];
    const hasMedia = media.length > 0;
    const isMultiMedia = media.length > 1;
    const firstMedia = media[0];

    const renderMediaItem = (item, isCarousel = false) => {
        const isVid = item?.content_type?.startsWith("video/");
        const style = {
            width: "100%",
            height: "100%",
            objectFit: "contain",
            borderRadius: isCarousel ? "0" : "8px",
            display: "block",
            backgroundColor: isCarousel ? "#000" : "transparent"
        };

        if (isVid) {
            return <video src={item.public_url} controls style={style} playsInline />;
        }
        return <img src={item.public_url} alt="media" style={style} />;
    };

    const renderMedia = () => {
        if (!hasMedia) return null;

        if (isMultiMedia) {
            return (
                <div style={{ flex: 1, minHeight: 0, borderRadius: "8px", overflow: "hidden", backgroundColor: "#000", position: "relative" }}>
                    <style>{`
                        .canvas-slick-carousel,
                        .canvas-slick-carousel .slick-list,
                        .canvas-slick-carousel .slick-track,
                        .canvas-slick-carousel .slick-slide {
                            height: 100% !important;
                        }
                        .canvas-slick-carousel .slick-slide > div {
                            height: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    `}</style>
                    <Carousel arrows infinite={false} className="canvas-slick-carousel" style={{ height: "100%" }}>
                        {media.map((item, index) => (
                            <div key={index} style={{ height: "100%" }}>
                                {renderMediaItem(item, true)}
                            </div>
                        ))}
                    </Carousel>
                </div>
            );
        }

        return (
            <div style={{ flex: 1, minHeight: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
                {renderMediaItem(firstMedia)}
            </div>
        );
    };

    log.d(platforms, "platforms in QEPC")

    return (
        <QurealCanvasWrapper
            actions={[
                <Button key="download" type="primary">Download</Button>,
                closeBtn
            ]}
            actions_left={[
                !isMobile && (
                    <Button
                        key="menu-btn"
                        icon={<MenuOutlined />}
                        onClick={() => {
                            if (setOpenCust) setOpenCust(!open_cust);
                        }}
                    />
                ),
                <h3 key="title" style={{ margin: 0, marginRight: "10px" }}>External Post</h3>,
            ]}
            header_height={50}
            open_cp={open_cust}
            setOpenCp={setOpenCust}
            controlPanel={
                <div style={{ padding: "15px", height: "100%", overflowY: "auto", display: "flex", flexDirection: "column" }}>
                    <div style={{ flex: 1 }}>
                        <SocialPostingBox
                            platforms={platforms}
                            entry_id={entry_id}
                            org_id={org_id}
                        />
                    </div>
                    {entry_id ? <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end",
                        paddingTop: "20px"
                    }}

                    >
                        <Popconfirm
                            title="Delete entry"
                            description="Are you sure you want to delete this entry?"
                            onConfirm={() => {
                                deleteMutation.mutate({
                                    collection: "qdb_calendar_entries",
                                    id: entry_id,
                                });
                            }}
                            okText="Yes"
                            cancelText="No"
                            okButtonProps={{ danger: true }}
                        >
                            <Button danger icon={<DeleteOutlined />} loading={deleteMutation.isLoading}>Delete</Button>
                        </Popconfirm>
                    </div> : null}
                </div>
            }
        >
            <div ref={ref} style={{
                width: "100%",
                height: "100%",
                padding: "15px",
                backgroundColor: "#f0f2f5",
                display: "flex",
                justifyContent: "center",
                alignItems: "stretch",
                boxSizing: "border-box",
                overflow: "hidden"
            }}>
                <div style={{
                    backgroundColor: "white",
                    padding: "15px",
                    borderRadius: "12px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "15px",
                    overflow: "hidden",
                    boxSizing: "border-box"
                }}>
                    {data?.caption && (
                        <div style={{
                            whiteSpace: "pre-wrap",
                            fontSize: "15px",
                            color: "#1c1e21",
                            lineHeight: "1.5",
                            wordBreak: "break-word",
                            flexShrink: 0,
                            maxHeight: "40%",
                            overflowY: "auto"
                        }}>
                            {data.caption}
                        </div>
                    )}
                    {renderMedia()}
                </div>
            </div>
        </QurealCanvasWrapper>
    );
}

export default QurealExternalPostCanvas;
